// extracted by css-extract-rspack-plugin
export default {"cls1":"InputForm-cls1_FbY","cls2":"InputForm-cls2_4eY InputForm-cls1_FbY"};